import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    unknownError: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Fallback message when an export failure event has no message body */
            unknownError: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExportProgressContext.unknownError?c=1pw5opjau19f1", defaultMessage: "Unknown error" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
